import { BridgeProviderType } from '~/types'
import { getExplorerTransactionLinkChainId } from '~/utils/addresses'

import type { BridgeData } from '~/types'

// Relay hosts a receipt page keyed by providerTransactionId. Other providers
// (e.g. NearIntents) store their deposit address in that field, which has no
// receipt page — the destination-chain transaction is the receipt instead.
// A missing providerType means the bridge predates the field, which is Relay.
export const getBridgeReceipt = (
  bridgeData: BridgeData,
): { url: string; transactionId: string } | null => {
  const providerType = bridgeData.providerType ?? BridgeProviderType.RELAY

  if (providerType === BridgeProviderType.RELAY) {
    if (!bridgeData.providerTransactionId) return null
    return {
      url: `https://relay.link/transaction/${bridgeData.providerTransactionId}`,
      transactionId: bridgeData.providerTransactionId,
    }
  }

  const destinationHash =
    bridgeData.destinationTransactionHash ??
    bridgeData.destinationTransaction?.hash
  const url = getExplorerTransactionLinkChainId(
    destinationHash,
    bridgeData.destinationChainId,
  )

  if (!url || !destinationHash) return null
  return { url, transactionId: destinationHash }
}
